/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ClassificationItem } from './classificationItem';

export interface ShipLogClassRecord { 
    readonly id: string;
    date: string;
    groupUuid: string;
    groupName: string;
    thematicBlockTitle: string;
    topicTitle?: string;
    morningActivities?: string;
    afternoonActivities?: string;
    createdByName?: string;
    modifiedByName?: string;
    readonly classification: Array<ClassificationItem>;
}